// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-submenu [class^=\"el-icon-\"][data-v-0926b702] {\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
